import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { CryptoService } from '../crypto/crypto.services';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  constructor(private readonly httpService: AmplifyHttpClient, private cryptoService: CryptoService) {}

  createNoteWithEncryption(payload, selectedSecurity_key = null, is_create = true) {
    let encryption_key;
    if (selectedSecurity_key == null) {
      encryption_key = this.cryptoService.generateEncryptionKey(payload.user_pk, null, null);
    } else {
      encryption_key = this.cryptoService.generateEncryptionKey(payload.user_pk, selectedSecurity_key);
    }

    payload.notes = JSON.stringify(this.cryptoService.encryptData(JSON.stringify(payload.notes), encryption_key));
    if (is_create) {
      return this.createNote({
        ...payload,
      });
    } else {
      return this.updateNote({
        ...payload,
      });
    }
  }
  createNote(request) {
    const url = `api/note`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createNotWtihEncrption() {}

  updateNote(request) {
    const url = `api/note`;
    return this.httpService.patch(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getNote(checklistId, type) {
    const url = `api/note/${type}/${checklistId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getForTask(checklistId) {
    const url = `api/note/task/${checklistId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getForm(checklistId, type = 'form') {
    const url = `api/note/${type}/${checklistId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  deleteNote(Id) {
    const url = `api/note/${Id}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
